<template>
    <section class="service service_screen vidget_wrap">
        <div class="service__header page__section detectMobVisibility">
            <h2 class="page__h1 service__h2">
                <span class="textHide"><span>{{ $t('service.title') }}</span></span>
            </h2>
            <div class="service__text textFade">{{ $t('service.descr') }}</div>
            <a :href="$t('service.manifest_link')" class="button button_white" target="_blank"><span class="button__text">{{ $t('buttons.service_manifesto') }} →</span></a>
        </div>
        <div class="service__list page__section animSection">
            <div class="service__column textFade detectMobVisibility" data-chain="1">
                <div class="service__name">{{ $t('service.pre_sale_title') }}</div>
                <div class="service__item">{{ $t('service.pre_sale_info1') }}</div>
                <div class="service__item">{{ $t('service.pre_sale_info2') }}</div>
                <div class="service__item">{{ $t('service.pre_sale_info3') }}</div>
            </div>
            <div class="service__column textFade detectMobVisibility" data-chain="2">
                <div class="service__name">{{ $t('service.sale_title') }}</div>
                <div class="service__item">{{ $t('service.sale_info1') }}</div>
                <div class="service__item">{{ $t('service.sale_info2') }}</div>
                <div class="service__item">{{ $t('service.sale_info3') }}</div>
            </div>
            <div class="service__column textFade detectMobVisibility" data-chain="3">
                <div class="service__name">{{ $t('service.post_sale_title') }}</div>
                <div class="service__item">{{ $t('service.post_sale_info1') }}</div>
                <div class="service__item">{{ $t('service.post_sale_info2') }}</div>
                <div class="service__item">{{ $t('service.post_sale_info3') }}</div>
            </div>
            <div class="service__column textFade detectMobVisibility" data-chain="3">
                <div class="service__name">{{ $t('service.digital_title') }}</div>
                <div class="service__item">{{ $t('service.digital_info1') }}</div>
                <div class="service__item">{{ $t('service.digital_info2') }}</div>
                <div class="service__item">{{ $t('service.digital_info3') }}</div>
                <div class="service__item">{{ $t('service.digital_info4') }}</div>
            </div>
        </div>
    </section>
</template>

<script>
    import params from '../../public/site_config.json'

    export default {
        data() {
            return {
                serviceManifesto: params.serviceManifesto_link
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="stylus" scoped>
    .service__list.animSection
        position relative
        overflow hidden

        &:before
            width 100%
            height 100%
            position absolute
            top 0
            left 0
            background #FAFBFC
            content ''
    
    .service_screen
        display flex
        flex-direction column
        justify-content space-between
        
        @media (min-width 1024px)
            min-height 100vh
    
    .service
        background #fff

    .service__h2
        margin-top 75px

        @media (min-width 700px)
            margin-top 48px
        
    .service__text
        padding 32px 0
        width 70%

        @media (max-width 400px)
            width 290px
        
    .service__list
        counter-reset service
        padding 64px 20px

        @media (min-width 700px)
            padding 70px 35px
        
        @media (min-width 1024px)
            padding 130px 80px
            display grid
            grid-template-rows: repeat(2, 1fr);
            grid-template-columns: repeat(2, 332px);
            grid-gap 64px
            
        @media (min-width 1600px)
            padding 130px 100px
            
        @media (min-width 1920px)
            grid-template-rows: repeat(1, 1fr);
            grid-template-columns: repeat(4, 332px);

    .service__column

        &:not(:last-child)
            margin-bottom 32px

    .service__name
        padding-left 16px
        font-weight bold
        line-height 1
        margin-bottom 12px
        position relative

        &:before
            counter-increment service
            content: "0" counter(service);
            position absolute
            left -5px
            top -15px
            font-size 12px
            line-height 1
            color #C6C8CC

    .service__item
        padding 7px 0 7px 16px
        position relative
        line-height 1.5
        color #808080
        max-width 280px

        &:before
            content ''
            background #C6C8CC
            width 8px
            height 1px
            position absolute
            left 0
            top 16px

</style>